import styled from 'styled-components'
import theme from '../../styles/theme'

export const StyledHeader = styled.header`
  padding-top: 13px;
  padding-bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${({ haveMenu }) =>
    haveMenu ? 'inset 0px -1px 0px rgba(0, 0, 0, 0.25)' : 'none'};
`

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: ${({ haveMenu }) => (haveMenu ? '16px' : '0px')};
`

export const HeaderTitle = styled.title`
  font-weight: 700;
  font-size: 20px;
  font-style: normal;
  line-height: 24px;
  padding: 5px;
  display: block;
  color: ${theme.color.black};
`

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: ${({ workflow }) =>
    workflow === 'Pre-Consent' ? '16px' : 'none'};
`
export const MeanuLable = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: ${theme.color.black};
  margin-bottom: 0px;
`
